import React from 'react'
import { Row, Col } from 'react-bootstrap'
import amexIcon from '../../../../../../../img/card_amex.svg'
import visaIcon from '../../../../../../../img/card_visa.svg'
import mastercardIcon from '../../../../../../../img/card_mastercard.svg'
import { FadeButton, SolidButton } from '../../../../../../library/button'
import { useDispatch, useSelector } from 'react-redux'
import { changeCompanyModal, setActivePaymentMethod } from '../../../../../../../redux/actions/company'
import './style.scss'

const Index = ({details}) => {

    const dispatch = useDispatch()

    const defaultMethod = useSelector(state => state.company.paymentMethods?.default)

    const determineIcon = brand => {
        switch(brand){
            case "amex":
                return amexIcon
            case "visa":
            return visaIcon
            case "mastercard":
                return mastercardIcon
            default:
            return null
        }
    }

    const clickRemoveMethod = () => {
        dispatch(setActivePaymentMethod(details))
        dispatch(changeCompanyModal({removePaymentMethod: true}))
    }

    const clickUpdateMethod = () => {
        dispatch(setActivePaymentMethod(details))
        dispatch(changeCompanyModal({updatePaymentMethod: true}))
    }

    return(
        <Col md={6} className="single-card-col">
            <div className="inner-single-card-container">
                <div className="name-container">
                    <h4 className="card-name">{details.name}</h4>
                    {defaultMethod === details.id && <FadeButton color="green" size="xs" title="Primærvalg"/>}
                </div>
                <Row className="details-row">
                    <Col className="icon-col my-auto">
                        <img className="card-brand" src={determineIcon(details.brand)}/>
                    </Col>
                    <Col className="info-col my-auto">
                        <h4 className="card-type-ending">{details.brand} **** {details.last4}</h4>
                        <p className="card-expiry-date">Kortet utløper {details.exp_month}/{details.exp_year}</p>
                    </Col>
                    <Col className="button-col my-auto text-right">
                        <SolidButton onClick={() => clickUpdateMethod()} size="md" title="Endre" spacing="right" color="gray"/>
                        <SolidButton onClick={() => clickRemoveMethod()} size="md" title="Slett" spacing="right" color="gray"/>
                    </Col>
                    </Row>
            </div>
        </Col>
    )
}

export default Index